const UserIcon = props => {
  // ** Props
  const { icon, iconProps, componentType } = props
  const IconTag = icon

  if (!IconTag) {
    return null
  }

  if (componentType === 'vertical-menu' && IconTag.__navLucide) {
    return <IconTag {...iconProps} />
  }

  let styles
  if (componentType === 'search') {
    styles = {
      fontSize: '2rem'
    }
  } else if (componentType === 'vertical-menu') {
    styles = {
      fontSize: '1.5rem'
    }
  } else if (componentType === 'horizontal-menu') {
    styles = {
      fontSize: '1rem'
    }
  } else {
    return null
  }

  // @ts-ignore
  return <IconTag {...iconProps} style={{ ...styles, ...iconProps?.style }} />
}

export default UserIcon
